import { LoadingGhost, SelectDropdown, StateHandler } from "src/components";
import styles from "./CompanySelector.module.scss";
import { useGetUserAccessMeQuery } from "src/datahandling/redux/api/rtkQueryCodeGen/accessApi/accessApiInjections";
import { useCustomerSettingsContext } from "src/contexts";
import clsx from "clsx";
import { useCompanySelectorTransformer } from "./Data/useCompanySelector.transform";

export namespace CompanySelector {
    export type Props = {};
}

export const CompanySelector = () => {
    const { setSelectedCompany, selectedCompany } = useCustomerSettingsContext();
    const userAccessQuery = useGetUserAccessMeQuery({ ignoreCache: false });

    return(
        <StateHandler 
            statefullObjectMap={{ userAccessQuery }}
            loadingGraphic={<LoadingGhost width="10rem" height="1.75rem" />}
        >
            {(data) => {
                const { options, selected } = useCompanySelectorTransformer(data.userAccessQuery, selectedCompany);

                return(
                    <SelectDropdown
                        onChange={(item) => {
                            setSelectedCompany(item.value);
                        }}
                        trigger={{
                            variant: "ghost",
                            color: "neutral",
                            size: "medium",
                            text: selected.text,
                            useChevrons: true,
                        }}
                        options={options}
                        preSelected={selected ?? options[0]}
                        className={clsx(styles.item, {
                            [`${styles["item--collapsed"]}`]: !open,
                        })}
                    />
                );
            }}
        </StateHandler>
    );
}